import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
} from '@mui/material';

import { Delete } from '@mui/icons-material';
import { LicenseForm } from './types';

interface Props {
  licenses: LicenseForm[];
  handleDeleteLicense: (index: number) => void;
  handleLicenseClicked: (index: number) => void;
  selectedLicenseIndex: number;
}

const LicenseList = ({
  licenses,
  handleDeleteLicense,
  handleLicenseClicked,
  selectedLicenseIndex,
}: Props) => {
  return (
    <>
      <List subheader={<ListSubheader disableSticky>Licenses</ListSubheader>}>
        {licenses?.map((license, index) => (
          <ListItem
            button
            onClick={() => handleLicenseClicked(index)}
            key={index}
            selected={selectedLicenseIndex === index}
          >
            <ListItemText>{license.serial}</ListItemText>
            <ListItemText>{license.demoStartDate}</ListItemText>
            <ListItemSecondaryAction onClick={() => handleDeleteLicense(index)}>
              <IconButton edge='end' size='large'>
                <Delete />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default LicenseList;
